import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Link } from 'react-router-dom';
import truncate from 'lodash/truncate';

const ProductBlogPost = ({ post }) => {
  const title = get(post, 'data.title[0].text', '');
  const image = get(post, 'data.cover.224x126', '');

  return (
    <Link to={{ pathname: `/blog/${post.uid}` }} className="product-blog-post">
      <div className="cover-image">
        <div className="responsive-image responsive-image--16by9">
          <img
            className="img-fluid"
            src={image.url}
            alt={image.url}
            loading="lazy"
          />
        </div>
      </div>
      <div className="blog-post-content">
        <h3 className="blog-post-title">
          {truncate(title, { length: 60, separator: ' ' })}
        </h3>
      </div>
    </Link>
  );
};

ProductBlogPost.propTypes = {
  post: PropTypes.shape({}),
};

ProductBlogPost.defaultProps = {
  post: {},
};

export default ProductBlogPost;
